import { Stack, TextField, Typography } from '@chronosphereio/chrono-ui';
import { produce } from 'immer';
import { useState } from 'react';
import { ExternalPanelSpec } from '@/core';
import {
  OptionsEditorColumn,
  OptionsEditorControl,
  OptionsEditorGrid,
  OptionsEditorGroup,
} from '@/plugin-editor-components';
import { OptionsEditorProps } from '@/plugin-system';
import { VariablesTable } from '@/plugin-system/runtime/ContextLinkTypesProvider/VariablesTable';

export const ExternalPanelOptionsEditor = ({ onChange, value }: OptionsEditorProps<ExternalPanelSpec>) => {
  const [localPanel, setLocalPanel] = useState<ExternalPanelSpec>(value);

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center', m: (t) => t.spacing(3, 0, 2.5) }}>
        <TextField
          placeholder="https://example.com/${env}?start=${__start_time}"
          label="URL"
          sx={{ flex: 1 }}
          value={localPanel.url}
          onChange={(e) => {
            setLocalPanel(
              produce(localPanel, (draft) => {
                draft.url = e.target.value;
              })
            );
          }}
          onBlur={(e) =>
            onChange(
              produce(localPanel, (draft) => {
                draft.url = e.target.value;
              })
            )
          }
        />
      </Stack>
      <OptionsEditorGrid>
        <OptionsEditorColumn>
          <OptionsEditorGroup title="Variables">
            <Typography variant="body2" mb={1}>
              The following variables are available to use in the URL:
            </Typography>
            <VariablesTable />
          </OptionsEditorGroup>
        </OptionsEditorColumn>
        <OptionsEditorColumn>
          <OptionsEditorGroup title="Embed dimensions">
            <OptionsEditorControl
              label="Static height (px)"
              control={
                <TextField
                  value={localPanel.content_height}
                  placeholder="(Optional)"
                  type="number"
                  onChange={(e) => {
                    setLocalPanel(
                      produce(localPanel, (draft) => {
                        draft.content_height = e.target.value ? Number(e.target.value) : undefined;
                      })
                    );
                  }}
                  onBlur={(e) =>
                    onChange(
                      produce(localPanel, (draft) => {
                        draft.content_height = e.target.value ? Number(e.target.value) : undefined;
                      })
                    )
                  }
                />
              }
            />
            <OptionsEditorControl
              label="Static width (px)"
              control={
                <TextField
                  value={localPanel.content_width}
                  placeholder="(Optional)"
                  type="number"
                  onChange={(e) => {
                    setLocalPanel(
                      produce(localPanel, (draft) => {
                        draft.content_width = e.target.value ? Number(e.target.value) : undefined;
                      })
                    );
                  }}
                  onBlur={(e) =>
                    onChange(
                      produce(localPanel, (draft) => {
                        draft.content_width = e.target.value ? Number(e.target.value) : undefined;
                      })
                    )
                  }
                />
              }
            />
          </OptionsEditorGroup>
        </OptionsEditorColumn>
      </OptionsEditorGrid>
    </>
  );
};
